import { AxiosRequestConfig } from "axios";
import { ApiService } from "../../../config";
import { handleError } from "../../../utils/parseApiReturn";
import { toast } from "react-toastify";

interface GetCasesParams {
  token: string;
  page?: number;
  size?: number;
  query?: string;
  sort?: string;
  localidade?: string;
  categoryIds?: number[];
}

const getCases = async (params: GetCasesParams): Promise<any> => {
  try {
    const { token, ...queryParams } = params;
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: queryParams,
      paramsSerializer: (p) =>
        Object.entries(p)
          .flatMap(([key, val]) =>
            Array.isArray(val)
              ? val.map((v) => `${key}=${encodeURIComponent(v)}`)
              : [`${key}=${encodeURIComponent(val as string)}`]
          )
          .join("&"),
    };

    const result = await ApiService.get("/business-profiles/cases", config);
    const { data, error } = result.data;
    if (error) {
      const { message } = handleError(error, "Erro ao obter Clientes");
      toast.error(message);
      return null;
    }
    return data;
  } catch (error) {
    const { message } = handleError(error, "Erro inesperado ao obter Clientes");
    toast.error(message);
    return null;
  }
};

export const CasesService = {
  getCases,
};
